import type { Company } from './ContactRequestContext'

/**
 * Sort a list of campaign companies alphabetically (A->Z) by name.
 *
 * Used for the contact-request "final QA" list so reviewers see a predictable
 * order before requesting contacts (FIR-7060). The list shown there is merged
 * from several status buckets, so its order is otherwise arbitrary. Comparison
 * is case- and locale-insensitive, and null/undefined names sort as empty
 * strings (ordered before any real name, but never throwing).
 *
 * Returns a new array; the input is not mutated.
 */
export function sortCompaniesByName<T extends Pick<Company, 'name'>>(
  companies: T[]
): T[] {
  return [...companies].sort((a, b) =>
    (a.name ?? '').localeCompare(b.name ?? '', undefined, {
      sensitivity: 'base',
    })
  )
}
